import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import type { ApplicationStatus } from "../types";

interface Props {
  jobTitle: string | null;
  companyName: string | null;
  sourceUrl: string;
  status: ApplicationStatus;
  statusUpdating: boolean;
  onStatusChange: (status: ApplicationStatus) => void;
}

const STATUS_OPTIONS: { value: ApplicationStatus; label: string }[] = [
  { value: "saved", label: "Saved" },
  { value: "applied", label: "Applied" },
  { value: "interview", label: "Interview" },
  { value: "offer", label: "Offer" },
  { value: "rejected", label: "Rejected" },
  { value: "expired", label: "Expired" },
  { value: "deleted", label: "Deleted" },
];

export default function JobSummaryBar({
  jobTitle,
  companyName,
  sourceUrl,
  status,
  statusUpdating,
  onStatusChange,
}: Props) {
  const label = [jobTitle || "Unnamed Role", companyName || "Unknown Company"]
    .filter(Boolean)
    .join(" — ");

  return (
    <div className="flex items-center justify-between gap-4 px-6 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
      <h1 className="flex items-center gap-1.5 text-base font-semibold text-slate-900 dark:text-slate-100 m-0">
        <a
          href={sourceUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-blue-600 dark:text-blue-400 hover:underline no-underline"
        >
          {label}
          <ArrowTopRightOnSquareIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        </a>
      </h1>

      <select
        value={status}
        onChange={(e) => onStatusChange(e.target.value as ApplicationStatus)}
        disabled={statusUpdating}
        aria-label="Application status"
        className="px-2.5 py-1.5 border border-slate-300 dark:border-slate-600 rounded text-sm bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 disabled:opacity-50"
      >
        {STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
